/**
 * ```
 * @prettier
 * ```
 */

import Vue from "vue";
import VueRouter from "vue-router";

/**
 * Views
 */
import CheckoutPage from "../views/checkout/index.vue";
import HomePage from "../views/home/index.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: "history",
  routes: [
    {
      component: CheckoutPage,
      name: "CheckoutPage",
      path: "/checkout",
    },
    {
      component: HomePage,
      name: "HomePage",
      path: "/",
    },
  ],
});

export default router;
